import {Pipe, PipeTransform} from '@angular/core';
import {OutageChartData} from 'frontend/src/app/modules/outage/interfaces/outage-chart-data.interface';

@Pipe({
    name: 'totalCustomersType',
    standalone: false,
})
export class TotalCustomersTypePipe implements PipeTransform {
    transform(value: OutageChartData): string {
        if (value.coveredCustomersType) {
            return `(${value.coveredCustomersType.charAt(0).toUpperCase() + value.coveredCustomersType.slice(1)})`;
        }
        return value.modelCount && value.coveredCustomers === value.modelCount ? '(Modeled)' : '(Collected)';
    }
}
